<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(dateRange)="data" style="'left':'80px';">
          {{formatDate(new Date(data.item.startDate))}}至{{formatDate(new Date(data.item.endDate))}}
        </template>
        <template v-slot:cell(status)="data" style="'left':'80px';">
          {{data.item.status==1?'待收款':data.item.status==2?'已收款':'作废' }}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'dateRange' ? '150px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'feeItemName', stickyColumn: true, label: '费项'},
        {key: 'dateRange', label: '计费区间'},
        {key: 'amount', label: '应收金额(元)'},
        {key: 'paymentAmount', label: '已收金额(元)'},
        {key: 'stayAmount', label: '剩余应收金额(元)'},
        {key: 'status', label: '状态'},
      ],
      items: [],
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data
    });
  },
  methods: {
    init() {
    },
    formatDate(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + m + '-' + d;
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
tr th:nth-child(2), tr td:nth-child(2) {
  left: 30px !important;
}
</style>
